import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Abholung',
        [ORDER_METHODS.DELIVERY]: 'Lieferung',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Zimmerservice',
          [RoomServiceLocationType.TableService]: 'Tischservice',
        },
      },
    },
    delivery_info: {
      title: 'Abgabe Optionen',
    },
    customer_info: {
      title: 'Kontakt',
    },
    payment: {
      title: 'Zahlung',
    },
    request_invoice: {
      title: 'Rechnung anfordern',
      form: {
        is_receipt_required: {
          label: 'Rechnung via Email erhalten',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Tür klingeln',
        [DropoffAction.Sms]: 'Kontaktiere mich per SMS bei Ankunft',
      },
    },
  },
  buttons: {
    change: 'Ändern',
    add_delivery_note: 'Lieferanweisung hinzufügen',
  },
};
